import { IVideoPlayerProps } from '@/types/VideoPlayerProps';
import getPublicConfig from '@/utils/getPublicConfig';

const publicRuntimeConfig = getPublicConfig();
export function VimeoVideoPlayer({
  title,
  width,
  height,
  videoId,
  className,
}: IVideoPlayerProps): JSX.Element {
  return (
    <iframe
      className={className}
      title={title}
      src={`https://player.vimeo.com/video/${videoId}?h=${publicRuntimeConfig.VIMEO_HASH_ID}&badge=0&autopause=0&player_id=0&app_id=${publicRuntimeConfig.VIMEO_APP_ID}`}
      width={width}
      height={height}
      frameBorder="0"
      allowFullScreen
    />
  );
}

VimeoVideoPlayer.defaultProps = {
  className: '',
};
